import { useEffect, useMemo, useState } from 'react';

export default function usePagination(props = {}) {
  const {
    defaultPage = 1,
    itemsPerPage = 1,
    numberOfPages,
    onPageChange,
    totalItems = 1,
  } = props;

  const [currentPage, setCurrentPage] = useState(defaultPage);
  const [firstItemNumber, setFirstitemNumber] = useState();
  const [lastItemNumber, setLastItemNumber] = useState();

  useEffect(() => {
    setFirstitemNumber((currentPage - 1) * itemsPerPage + 1);
  }, [currentPage, itemsPerPage]);

  useMemo(() => {
    setLastItemNumber(Math.min(totalItems, currentPage * itemsPerPage));
  }, [currentPage, itemsPerPage, totalItems]);

  const handleClick = (event, value) => {
    event.preventDefault();

    setCurrentPage(value);
    onPageChange(event, value);
  };

  const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
  };

  const buttonPage = (type) => {
    switch (type) {
      case 'previous':
        return currentPage - 1;
      case 'next':
        return currentPage + 1;
      default:
        return null;
    }
  };

  const itemList = ['previous', ...range(1, numberOfPages), 'next'];

  const items = itemList.map((item) =>
    typeof item === 'number'
      ? {
          onClick: (event) => {
            handleClick(event, item);
          },
          type: 'page',
          page: item,
          selected: item === currentPage,
          disabled: item === currentPage,
          'aria-current': item === currentPage ? 'true' : undefined,
        }
      : {
          onClick: (event) => {
            handleClick(event, buttonPage(item));
          },
          type: item,
          page: buttonPage(item),
          selected: false,
          disabled:
            item === 'next'
              ? currentPage * itemsPerPage >= totalItems
              : currentPage <= 1,
        },
  );

  return {
    items,
    firstItemNumber,
    lastItemNumber,
  };
}
